// NOTE - this needs to be moved into ux-tread-cart-redux (partnercart-redux should be folded into cart-redux, but keep tread-partnercart separate)
import { createSelector } from 'reselect';
import getAllCartErrors from './get-all-cart-errors';

const getFilteredCartErrors = createSelector(
  getAllCartErrors,
  (state, props) => props.errorsToExclude || [],
  (errors, errorsToExclude) =>
    errors.filter(({ crcCode }) => crcCode && errorsToExclude.indexOf(crcCode) < 0),
);

export default getFilteredCartErrors;
